var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Accordion, AccordionSet, Button, Col, ExpandAllButton, Headline, Icon, KeyValue, List, Loading, MenuSection, MetaSection, Modal, ModalFooter, MultiColumnList, Pane, Row, } from '@folio/stripes/components';
import { IfPermission, useOkapiKy, useStripes } from '@folio/stripes/core';
import classNames from 'classnames';
import React, { useMemo, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useQuery } from 'react-query';
import InfoPaneHours from '../../components/InfoPaneHours';
import permissions from '../../types/permissions';
import { getLocalizedDate } from '../../utils/DateUtils';
import { generateExceptionalOpeningRows } from '../../utils/InfoPaneUtils';
import ifPermissionOr from '../../utils/ifPermissionOr';
import css from './InfoPane.css';
export var InfoPane = function (props) {
    var _a, _b, _c, _d, _e, _f;
    var intl = useIntl();
    var stripes = useStripes();
    var calendar = props.calendar;
    var _g = useState(false), showDeleteModal = _g[0], setShowDeleteModal = _g[1];
    var _h = useState(false), deleteModalSubmitting = _h[0], setDeleteModalSubmitting = _h[1];
    var ky = useOkapiKy();
    var metadata = {
        createdBy: useQuery(['ui-calendar', 'users', (_a = calendar === null || calendar === void 0 ? void 0 : calendar.metadata) === null || _a === void 0 ? void 0 : _a.createdByUserId], function () { var _a; return ky.get("users/".concat((_a = calendar === null || calendar === void 0 ? void 0 : calendar.metadata) === null || _a === void 0 ? void 0 : _a.createdByUserId)).json(); }, { enabled: !!((_b = calendar === null || calendar === void 0 ? void 0 : calendar.metadata) === null || _b === void 0 ? void 0 : _b.createdByUserId) }).data,
        createdAt: (_c = calendar === null || calendar === void 0 ? void 0 : calendar.metadata) === null || _c === void 0 ? void 0 : _c.createdDate,
        updatedBy: useQuery(['ui-calendar', 'users', (_d = calendar === null || calendar === void 0 ? void 0 : calendar.metadata) === null || _d === void 0 ? void 0 : _d.updatedByUserId], function () { var _a; return ky.get("users/".concat((_a = calendar === null || calendar === void 0 ? void 0 : calendar.metadata) === null || _a === void 0 ? void 0 : _a.updatedByUserId)).json(); }, { enabled: !!((_e = calendar === null || calendar === void 0 ? void 0 : calendar.metadata) === null || _e === void 0 ? void 0 : _e.updatedByUserId) }).data,
        updatedAt: (_f = calendar === null || calendar === void 0 ? void 0 : calendar.metadata) === null || _f === void 0 ? void 0 : _f.updatedDate,
    };
    var exceptions = useMemo(function () {
        var ex = {
            openings: [],
            closures: [],
        };
        calendar === null || calendar === void 0 ? void 0 : calendar.exceptions.forEach(function (exception) {
            if (exception.openings.length === 0) {
                ex.closures.push(exception);
            }
            else {
                exception.openings.sort(function (a, b) {
                    return Math.sign(new Date("".concat(a.startDate)).getTime() -
                        new Date("".concat(b.startDate)).getTime());
                });
                ex.openings.push(exception);
            }
        });
        ex.openings.sort(function (a, b) {
            return Math.sign(new Date("".concat(a.startDate)).getTime() -
                new Date("".concat(b.startDate)).getTime());
        });
        return {
            openings: generateExceptionalOpeningRows(intl, ex.openings),
            closures: ex.closures.map(function (exception) { return ({
                name: exception.name,
                startDate: getLocalizedDate(intl, exception.startDate),
                endDate: getLocalizedDate(intl, exception.endDate),
            }); }),
        };
    }, [calendar, intl]);
    if (calendar === undefined || calendar === null) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Pane, { paneTitle: calendar.name, defaultWidth: "30%", centerContent: true, onClose: props.onClose, dismissible: true, actionMenu: function (_a) {
                var onToggle = _a.onToggle;
                return ifPermissionOr(stripes, [permissions.UPDATE, permissions.CREATE, permissions.DELETE], React.createElement(MenuSection, { label: React.createElement(FormattedMessage, { id: "ui-calendar.infoPane.actions.label" }) },
                    React.createElement(IfPermission, { perm: permissions.UPDATE },
                        React.createElement(Button, { buttonStyle: "dropdownItem", onClick: onToggle, to: "".concat(props.editBasePath, "/").concat(calendar.id) },
                            React.createElement(Icon, { size: "small", icon: "edit" },
                                React.createElement(FormattedMessage, { id: "stripes-core.button.edit" })))),
                    React.createElement(IfPermission, { perm: permissions.CREATE },
                        React.createElement(Button, { buttonStyle: "dropdownItem", onClick: onToggle, to: {
                                pathname: props.creationBasePath,
                                search: new URLSearchParams({
                                    source: calendar.id,
                                }).toString(),
                            } },
                            React.createElement(Icon, { size: "small", icon: "duplicate" },
                                React.createElement(FormattedMessage, { id: "stripes-core.button.duplicate" })))),
                    React.createElement(IfPermission, { perm: permissions.DELETE },
                        React.createElement(Button, { buttonStyle: "dropdownItem", onClick: function () {
                                onToggle();
                                setShowDeleteModal(true);
                            } },
                            React.createElement(Icon, { size: "small", icon: "trash", iconRootClass: css.deleteButton },
                                React.createElement(FormattedMessage, { id: "stripes-core.button.delete" }))))));
            } },
            React.createElement(Headline, { size: "x-large", margin: "xx-small" }, calendar.name),
            React.createElement(AccordionSet, null,
                React.createElement(Row, { end: "xs" },
                    React.createElement(Col, { xs: true },
                        React.createElement(ExpandAllButton, null))),
                React.createElement(Accordion, { label: React.createElement(FormattedMessage, { id: "ui-calendar.infoPane.accordion.infoLabel" }) },
                    React.createElement(MetaSection, { createdBy: metadata.createdBy, createdDate: metadata.createdAt, lastUpdatedBy: metadata.updatedBy, lastUpdatedDate: metadata.updatedAt, showUserLink: stripes.hasPerm('ui-users.view') }),
                    React.createElement(Row, null,
                        React.createElement(Col, { xs: 12, sm: true },
                            React.createElement(KeyValue, { label: React.createElement(FormattedMessage, { id: "ui-calendar.infoPane.startDate" }) }, getLocalizedDate(intl, calendar.startDate))),
                        React.createElement(Col, { xs: 12, sm: true },
                            React.createElement(KeyValue, { label: React.createElement(FormattedMessage, { id: "ui-calendar.infoPane.endDate" }) }, getLocalizedDate(intl, calendar.endDate))))),
                React.createElement(Accordion, { label: React.createElement(FormattedMessage, { id: "ui-calendar.infoPane.accordion.assignments" }) },
                    React.createElement(List, { items: props.dataRepository.getServicePointNamesFromIds(calendar.assignments), listStyle: "bullets", isEmptyMessage: React.createElement("span", { className: css.noValue },
                            React.createElement(FormattedMessage, { id: "ui-calendar.infoPane.accordion.assignments.empty" })) })),
                React.createElement(Accordion, { label: React.createElement(FormattedMessage, { id: "ui-calendar.infoPane.accordion.hours" }) },
                    React.createElement(InfoPaneHours, { calendar: calendar })),
                React.createElement(Accordion, { label: React.createElement(FormattedMessage, { id: "ui-calendar.infoPane.accordion.exceptions.openings" }) },
                    React.createElement(MultiColumnList, { key: "".concat(calendar.id, "-ex-openings"), interactive: false, columnMapping: {
                            name: (React.createElement(FormattedMessage, { id: "ui-calendar.infoPane.accordion.exceptions.name" })),
                            start: (React.createElement(FormattedMessage, { id: "ui-calendar.infoPane.accordion.exceptions.start" })),
                            end: (React.createElement(FormattedMessage, { id: "ui-calendar.infoPane.accordion.exceptions.end" })),
                        }, columnWidths: {
                            name: 200,
                            start: { min: 100, max: 100 },
                            end: { min: 100, max: 100 },
                        }, getCellClass: function (defaultClass, _rowData, column) {
                            var _a;
                            return classNames(defaultClass, (_a = {},
                                _a[css.hoursCell] = column !== 'name',
                                _a[css.exceptionCell] = column !== 'name',
                                _a[css.dayCell] = column === 'name',
                                _a));
                        }, contentData: exceptions.openings, isEmptyMessage: React.createElement("div", { className: css.noValue },
                            React.createElement(FormattedMessage, { id: "ui-calendar.infoPane.accordion.exceptions.openings.empty" })) })),
                React.createElement(Accordion, { label: React.createElement(FormattedMessage, { id: "ui-calendar.infoPane.accordion.exceptions.closures" }) },
                    React.createElement(MultiColumnList, { key: "".concat(calendar.id, "-ex-closures"), interactive: false, columnMapping: {
                            name: (React.createElement(FormattedMessage, { id: "ui-calendar.infoPane.accordion.exceptions.name" })),
                            startDate: (React.createElement(FormattedMessage, { id: "ui-calendar.infoPane.accordion.exceptions.start" })),
                            endDate: (React.createElement(FormattedMessage, { id: "ui-calendar.infoPane.accordion.exceptions.end" })),
                        }, columnWidths: {
                            name: 200,
                            startDate: { min: 100, max: 100 },
                            endDate: { min: 100, max: 100 },
                        }, contentData: exceptions.closures, isEmptyMessage: React.createElement("div", { className: css.noValue },
                            React.createElement(FormattedMessage, { id: "ui-calendar.infoPane.accordion.exceptions.closures.empty" })) })))),
        React.createElement(Modal, { dismissible: true, onClose: function () { return setShowDeleteModal(false); }, open: showDeleteModal, label: React.createElement(FormattedMessage, { id: "ui-calendar.infoPane.deletionModal.label" }), "aria-label": intl.formatMessage({
                id: 'ui-calendar.infoPane.deletionModal.label',
            }), size: "small", footer: React.createElement(ModalFooter, null,
                React.createElement(Button, { buttonStyle: "danger", disabled: deleteModalSubmitting, onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                        var e_1, _a;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0:
                                    setDeleteModalSubmitting(true);
                                    _b.label = 1;
                                case 1:
                                    _b.trys.push([1, 3, 5, 6]);
                                    return [4 /*yield*/, props.dataRepository.deleteCalendar(calendar)];
                                case 2:
                                    _b.sent();
                                    props.onClose(); // will return to parent view automatically
                                    return [3 /*break*/, 6];
                                case 3:
                                    e_1 = _b.sent();
                                    // eslint-disable-next-line no-console
                                    console.error(e_1);
                                    // eslint-disable-next-line no-alert
                                    _a = alert;
                                    return [4 /*yield*/, e_1.response.text()];
                                case 4:
                                    // eslint-disable-next-line no-alert
                                    _a.apply(void 0, [_b.sent()]);
                                    return [3 /*break*/, 6];
                                case 5:
                                    setShowDeleteModal(false);
                                    setDeleteModalSubmitting(false);
                                    return [7 /*endfinally*/];
                                case 6: return [2 /*return*/];
                            }
                        });
                    }); } }, deleteModalSubmitting ? (React.createElement(Loading, null)) : (React.createElement(FormattedMessage, { id: "stripes-core.button.delete" }))),
                React.createElement(Button, { onClick: function () { return setShowDeleteModal(false); } },
                    React.createElement(FormattedMessage, { id: "stripes-core.button.cancel" }))) },
            React.createElement(FormattedMessage, { id: "ui-calendar.infoPane.deletionModal.contents", values: { name: calendar.name } }))));
};
export default InfoPane;
